import ColoredIcon from "components/ColoredIcon/ColoredIcon";
import React from "react";
import * as styles from "./MilestoneItem.module.scss";
import { Icon, IconName } from "@silversea-ssc/ui-components-react";

type Props = {
  icon?: string;
  normalIcon?: IconName;
  customIconUrl?: string;
  title?: string;
  description?: string;
};
const MilestoneItem: React.FC<Props> = ({
  icon,
  normalIcon,
  customIconUrl,
  title,
  description
}) => {
  return (
    <div className={styles.item}>
      {icon && <ColoredIcon className={styles.icon} iconName={icon} />}
      {normalIcon && (
        <Icon
          name={normalIcon}
          className={styles.normalIcon}
          padding={false}
          size="4x"
        />
      )}
      {customIconUrl && (
        <img
          src={customIconUrl}
          alt="icon"
          loading="lazy"
          className={styles.icon}
        />
      )}
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.description}>{description}</div>
    </div>
  );
};

export default MilestoneItem;
